import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SendMessage from "../components/SendMessage";
import axios from "axios";
import MessagesBox from "../components/MessagesBox";
import AddMedicine from "../components/AddMedicine";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Prescriptions from "../components/patientUI/Prescriptions";

function Profile() {
  const [messages, setMessages] = useState(null);
  const [name, setName] = useState(null);
  const [prescriptions, setPrescriptions] = useState([]);

  const str = window.location.href;
  const links = str.split("/");

  const removePatient = () => {
    axios
      .get(`/destroyPatient/${localStorage.getItem("currentProfile")}`)
      .then((res) => {
        console.log("Removed");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  localStorage.setItem("currentProfile", links[links.length - 1]);

  useEffect(() => {
    const link = `/getMessagesDoctor/${localStorage.getItem(
      "currentProfile"
    )}/${localStorage.getItem("user")}`;
    axios
      .get(link)
      .then((res) => {
        setMessages(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`user/${localStorage.getItem("currentProfile")}`)
      .then((res) => {
        setName(res.data.name);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`/getPrescriptions/${localStorage.getItem("currentProfile")}`)
      .then((res) => {
        setPrescriptions(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let myMessagesMarkup = messages ? (
    <MessagesBox messages={messages}></MessagesBox>
  ) : (
      <p>loading</p>
    );

  return (
    <div>
      <Grid container style={{ flex: 1 }}>
        <Grid style={{ flex: 1, margin: "auto"}}>
          <Link
            style={{
              textDecoration: "none",
              color: "white",
              fontWeight: "bold",
              backgroundColor: "#3f51b5",
              padding: 10,
              margin: 10,
              borderRadius: 8,
              alignItems: "left",
            }}
            to="/home"
          >
            BACK
          </Link>
        </Grid>
        <Grid style={{ flex: 5 }}>
          <h2 style={{ fontWeight: 'normal' }}>
            Patient: <b>{name}</b>
          </h2>
        </Grid>

        <Grid style={{ flex: 1, margin: "auto"}}>
          <Button variant="contained" color="secondary" onClick={removePatient}>
            Remove patient
          </Button>
        </Grid>
      </Grid>

      <Grid container style={{ flex: 1 }}>
        <Grid style={{ flex: 1, marginRight: 20, marginLeft: 10 }}>
          <AddMedicine></AddMedicine>
          <h1>Patient's prescriptions</h1>
          <Prescriptions prescriptions={prescriptions}></Prescriptions>
        </Grid>

        <Grid style={{ flex: 1 }}>
          <div
            style={{
              margin: 10,
            }}
          >
            {myMessagesMarkup}
            <SendMessage
              uid={localStorage.getItem("currentProfile")}
            ></SendMessage>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Profile;
